webpackJsonp([1],{

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(105),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 104:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main', [_c('article', [_c('h1', [_vm._v("A working function for removing duplicates from a list of email addresses.")]), _vm._v(" "), _c('p', [_vm._v("In any language(s) of your choice, write a working function that removes all duplicates from an unsorted list of email addresses.  You may assume any input data structure that your like.  Do not use built-in library functions that make the problem trivial.")]), _vm._v(" "), _c('h3', [_vm._v("Requirements:")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', [_c('h1', [_vm._v("Tests")]), _vm._v(" "), _c('tests')], 1), _vm._v(" "), _c('section', [_c('h1', [_vm._v("Summary")]), _vm._v(" "), _c('about')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Leave the resulting list in the original order. (same as the input).")]), _vm._v(" "), _c('li', [_vm._v("The function should be able to handle 100,000 email addresses containing 50% randomly placed duplicates in well under 1 second on a typical modern laptop.")]), _vm._v(" "), _c('li', [_vm._v("Include a simple test suite that demonstrates the above two requirements are met.")]), _vm._v(" "), _c('li', [_vm._v("Deploy a demo live on the web somewhere.")])])
}]}

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tests"
  }, [_c('div', {
    staticClass: "test"
  }, [_c('h3', [_vm._v("Test 1: Order Is Maintained")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.testOrderComplete),
      expression: "!testOrderComplete"
    }],
    staticClass: "test-spinner"
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'results': true, 'show': _vm.testOrderComplete
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.orderedSet))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.expectedOrderedSet))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.resultOrderedSet))]), _vm._v(" "), (_vm.testOrderStatus) ? _c('p', {
    staticClass: "pass"
  }, [_vm._v("✔ Passed")]) : _c('p', {
    staticClass: "fail"
  }, [_vm._v("× Failed")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "test"
  }, [_c('h3', [_vm._v("Test 2: Efficiancy")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.testEfficiencyComplete),
      expression: "!testEfficiencyComplete"
    }],
    staticClass: "test-spinner"
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'results': true, 'show': _vm.testEfficiencyComplete
    }
  }, [_c('p', [_c('strong', [_vm._v("Input List Length:")]), _vm._v(" " + _vm._s(_vm.largeSet.length))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Expected List Length:")]), _vm._v(" " + _vm._s(_vm.expectedLargeSetLength))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Result List Length:")]), _vm._v(" " + _vm._s(_vm.resultLargeSet.length))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Execution Time:")]), _vm._v(" " + _vm._s(this.executionTime) + " ms")]), _vm._v(" "), (_vm.testEfficiencyStatus) ? _c('p', {
    staticClass: "pass"
  }, [_vm._v("✔ Passed")]) : _c('p', {
    staticClass: "fail"
  }, [_vm._v("× Failed")])])], 1), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.tested
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Run Again")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Input List:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Expected List:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Result List:")])])
}]}

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('p', [_vm._v("The resulting function has been implemented using three programming languages: JavaScript, Java, and Elixir, with this demo using the JavaScript implementation.  They all solve the problem using the same methods:  Iterate through each item in the list, check if it exists in a map or set, and if not add it to the map or set and the new list. The full source code for this demo page, the function implementations, and cli tests can be found "), _c('a', {
    attrs: {
      "href": "https://github.com/steven-klein/unique-set-demo"
    }
  }, [_vm._v("here")]), _vm._v(" CLI tests are available for all three implementations if you have the required dependencies installed.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "data-structures-and-logic"
    }
  }, [_vm._v("Data Structures and Logic")]), _vm._v(" "), _c('p', [_vm._v("Using a map or set is useful when we are trying to remove duplicates since in one case it requires unique keys, and in the other unique values. Email addresses are inherently unique and can act as a key in a map.")]), _vm._v(" "), _c('p', [_vm._v("By adding items to a new list as we go, we're able to maintain the original order of the input list.")]), _vm._v(" "), _c('p', [_vm._v("The efficiency requirement should be met by a function with linear runtime O(n).")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "additional-considerations"
    }
  }, [_vm._v("Additional Considerations")]), _vm._v(" "), _c('p', [_vm._v("Depending on the source and reliability of the input data we may need to also consider the case where email addresses may exists with varying letter cases: "), _c('code', [_vm._v("STEVEN@example.com")]), _vm._v(", "), _c('code', [_vm._v("steven@example.com")]), _vm._v(", "), _c('code', [_vm._v("steven@EXAMPLE.COM")]), _vm._v(".  The implementations here do not check against this and makes the assumption the input data as been normalized in some way, in which case, each of those addresses would be considered unique.")]), _vm._v(" "), _c('p', [_vm._v("From my knowledge, few email providers enforce case sensitivity on the mailbox name, so if we did want to check against this, we should first convert the address string to all lowercase before any additional logic.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "javascript"
    }
  }, [_vm._v("JavaScript")]), _vm._v(" "), _c('p', [_vm._v("In the JavaScript implementation we take advantage of an objects map like properties which must be unique by creating a new default object and adding the email address as a property when it doesn't already exist.  The @ symbol should mean we can avoid collisions with built in properties.")]), _vm._v(" "), _c('p', [_vm._v("With a large data set this is probably better suited for a Node.js environment as opposed to being run in the browser.  Though I was surprised to see how quickly modern browsers handled a list of 100,000 entries.")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "language-javascript"
  }, [_c('span', {
    staticClass: "token keyword"
  }, [_vm._v("function")]), _vm._v(" uniqueSet "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("list"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("{")]), _vm._v("\n    "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("var")]), _vm._v(" interator "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("=")]), _vm._v(" list "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("||")]), _vm._v(" "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("this")]), _vm._v("\n    "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("var")]), _vm._v(" map "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("=")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("{")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("}")]), _vm._v("\n    "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("var")]), _vm._v(" "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("set")]), _vm._v(" "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("=")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("[")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("]")]), _vm._v("\n    "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("var")]), _vm._v(" index "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("=")]), _vm._v(" "), _c('span', {
    staticClass: "token number"
  }, [_vm._v("0")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("for")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("index"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(";")]), _vm._v(" index "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("<")]), _vm._v(" interator"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _vm._v("length"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(";")]), _vm._v(" index"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("++")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("{")]), _vm._v("\n      "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("if")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("!")]), _vm._v("map"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "token function"
  }, [_vm._v("hasOwnProperty")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("interator"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("[")]), _vm._v("index"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("]")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("{")]), _vm._v("\n        map"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("[")]), _vm._v("interator"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("[")]), _vm._v("index"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("]")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("]")]), _vm._v(" "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("=")]), _vm._v(" "), _c('span', {
    staticClass: "token boolean"
  }, [_vm._v("true")]), _vm._v("\n        "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("set")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "token function"
  }, [_vm._v("push")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("interator"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("[")]), _vm._v("index"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("]")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _vm._v("\n      "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("}")]), _vm._v("\n    "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("}")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("return")]), _vm._v(" "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("set")]), _vm._v("\n  "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("}")]), _vm._v("\n  ")])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "java"
    }
  }, [_vm._v("Java")]), _vm._v(" "), _c('p', [_vm._v("For the Java implementation our input data is a LinkedList and we use the HashSet structure for avoiding duplicates in our new LinkedList.")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "language-java"
  }, [_c('span', {
    staticClass: "token keyword"
  }, [_vm._v("import")]), _vm._v(" java"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _vm._v("util"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _vm._v("*"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(";")]), _vm._v("\n\n  "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("class")]), _vm._v(" "), _c('span', {
    staticClass: "token class-name"
  }, [_vm._v("UniqueSet")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("{")]), _vm._v("\n\n      "), _c('span', {
    staticClass: "token comment",
    attrs: {
      "spellcheck": "true"
    }
  }, [_vm._v("//ListIterator")]), _vm._v("\n      "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("public")]), _vm._v(" "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("static")]), _vm._v(" LinkedList"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("<")]), _vm._v("String"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v(">")]), _vm._v(" "), _c('span', {
    staticClass: "token function"
  }, [_vm._v("filter")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v(" LinkedList"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("<")]), _vm._v("String"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v(">")]), _vm._v(" list "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _vm._v("\n      "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("{")]), _vm._v("\n\n          LinkedList"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("<")]), _vm._v("String"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v(">")]), _vm._v(" filteredList "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("=")]), _vm._v(" "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("new")]), _vm._v(" "), _c('span', {
    staticClass: "token class-name"
  }, [_vm._v("LinkedList")]), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("<")]), _vm._v("String"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v(">")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(";")]), _vm._v("\n          HashSet"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("<")]), _vm._v("String"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v(">")]), _vm._v(" set "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("=")]), _vm._v(" "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("new")]), _vm._v(" "), _c('span', {
    staticClass: "token class-name"
  }, [_vm._v("HashSet")]), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("<")]), _vm._v("String"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v(">")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("list"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "token function"
  }, [_vm._v("size")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(";")]), _vm._v("\n          ListIterator"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("<")]), _vm._v("String"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v(">")]), _vm._v(" listIterator "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("=")]), _vm._v(" list"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "token function"
  }, [_vm._v("listIterator")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(";")]), _vm._v("\n\n          "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("while")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("listIterator"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "token function"
  }, [_vm._v("hasNext")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("{")]), _vm._v("\n              String current "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("=")]), _vm._v(" listIterator"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "token function"
  }, [_vm._v("next")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(";")]), _vm._v("\n              "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("if")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("!")]), _vm._v("set"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "token function"
  }, [_vm._v("contains")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("current"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _vm._v("\n              "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("{")]), _vm._v("\n                  set"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "token function"
  }, [_vm._v("add")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("current"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(";")]), _vm._v("\n                  filteredList"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _c('span', {
    staticClass: "token function"
  }, [_vm._v("add")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("current"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(";")]), _vm._v("\n              "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("}")]), _vm._v("\n          "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("}")]), _vm._v("\n\n          "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("return")]), _vm._v(" filteredList"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(";")]), _vm._v("\n      "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("}")]), _vm._v("\n  "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("}")]), _vm._v("\n  ")])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "elixir"
    }
  }, [_vm._v("Elixir")]), _vm._v(" "), _c('p', [_vm._v("I chose to also implement this in Elixir, for my own personal benefit, as it's a language that I'd like to have some working knowledge of.  Being a functional language we're required to use recursion to solve the problem of removing duplicates.  Similar to having multiple constructors that accept varying arguments, in some Object Oriented languages, Elixir employs the same concept to functions.")]), _vm._v(" "), _c('p', [_vm._v("Aside from the use of recursion, the problem is solved using a similar method as the JavaScript and Java implementations, using a Map to avoid duplicates and building a new list as we iterate.")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "language-elixir"
  }, [_c('span', {
    staticClass: "token keyword"
  }, [_vm._v("defmodule")]), _vm._v(" UniqueSet "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("do")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("def")]), _vm._v(" filter"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("[")]), _vm._v("head"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("|")]), _vm._v("tail"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("]")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("do:")]), _vm._v(" filter"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("[")]), _vm._v("head"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("|")]), _vm._v("tail"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("]")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("%")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("{")]), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("map:")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("%")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("{")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("}")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("list:")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("[")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("]")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("}")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _vm._v(";\n\n    "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("def")]), _vm._v(" filter"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("[")]), _vm._v("head"), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("|")]), _vm._v("tail"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("]")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(",")]), _vm._v(" filtered"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _vm._v(" "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("do")]), _vm._v("\n      "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("cond")]), _vm._v(" "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("do")]), _vm._v("\n          filtered"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _vm._v("map"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("[")]), _vm._v("head"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("]")]), _vm._v(" "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("!=")]), _vm._v(" "), _c('span', {
    staticClass: "token boolean"
  }, [_vm._v("nil")]), _vm._v(" "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("->")]), _vm._v("\n              filter"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("tail"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(",")]), _vm._v(" filtered"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _vm._v(";\n          "), _c('span', {
    staticClass: "token boolean"
  }, [_vm._v("true")]), _vm._v(" "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("->")]), _vm._v("\n              filter"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("tail"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("%")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("{")]), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("map:")]), _vm._v(" Map"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _vm._v("put"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("filtered"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _vm._v("map"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(",")]), _vm._v(" head"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "token number"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("list:")]), _vm._v(" "), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("[")]), _vm._v("head "), _c('span', {
    staticClass: "token operator"
  }, [_vm._v("|")]), _vm._v(" filtered"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _vm._v("list"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("]")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("}")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _vm._v(";\n      "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("end")]), _vm._v("\n    "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("end")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("def")]), _vm._v(" filter"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("[")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("]")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(",")]), _vm._v(" filtered"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("do:")]), _vm._v(" Enum"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _vm._v("reverse"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("(")]), _vm._v("filtered"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(".")]), _vm._v("list"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(")")]), _vm._v("\n\n  "), _c('span', {
    staticClass: "token keyword"
  }, [_vm._v("end")]), _vm._v("\n  ")])])])
}]}

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(31)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 26:
/***/ (function(module, exports) {

function uniqueSet (list) {
  var interator = list || this
  var map = {}
  var set = []
  var index = 0

  for (index; index < interator.length; index++) {
    if (!map.hasOwnProperty(interator[index])) {
      map[interator[index]] = true
      set.push(interator[index])
    }
  }

  return set
}

module.exports = uniqueSet


/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tests__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tests___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Tests__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_About__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_About__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Tests: __WEBPACK_IMPORTED_MODULE_0__components_Tests___default.a,
    About: __WEBPACK_IMPORTED_MODULE_1__components_About___default.a
  }
});

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about'
});

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_performance_now__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_performance_now___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_performance_now__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_uniqueSet_src__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_uniqueSet_src___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__js_uniqueSet_src__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tests',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default.a
  },
  data: function data() {
    return {
      orderedSet: window.orderedSet,
      largeSet: window.largeSet,
      expectedOrderedSet: ['angela@example.com', 'sandy@example.com', 'matthew@example.com', 'steven@example.com', 'david@example.com'],
      expectedLargeSetLength: 50000,
      resultOrderedSet: [],
      resultLargeSet: [],
      executionTime: 0,
      maxExecutionTime: 1000,
      testOrderComplete: false,
      testEfficiencyComplete: false
    };
  },

  computed: {
    tested: function tested() {
      return this.testOrderComplete && this.testEfficiencyComplete;
    },
    testOrderStatus: function testOrderStatus() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(this.expectedOrderedSet, this.resultOrderedSet);
    },
    testEfficiencyStatus: function testEfficiencyStatus() {
      return this.resultLargeSet.length === this.expectedLargeSetLength && this.executionTime < this.maxExecutionTime;
    }
  },
  methods: {
    reset: function reset() {
      this.testOrderComplete = false;
      this.testEfficiencyComplete = false;
      setTimeout(this.runTests, 1000);
    },
    testOrder: function testOrder() {
      this.resultOrderedSet = __WEBPACK_IMPORTED_MODULE_3__js_uniqueSet_src___default()(this.orderedSet);
      this.testOrderComplete = true;
    },
    testEfficiency: function testEfficiency() {
      var start = __WEBPACK_IMPORTED_MODULE_1_performance_now___default()();
      var end = null;
      this.resultLargeSet = __WEBPACK_IMPORTED_MODULE_3__js_uniqueSet_src___default()(this.largeSet);
      end = __WEBPACK_IMPORTED_MODULE_1_performance_now___default()();
      this.executionTime = (end - start).toFixed(3);
      this.testEfficiencyComplete = true;
    },
    runTests: function runTests() {
      this.testOrder();
      this.testEfficiency();
      this.tested = true;
    }
  },
  beforeMount: function beforeMount() {
    this.reset();
  }
});

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[27]);


// WEBPACK FOOTER //
// static/js/app.5df7cf4f8ec39ea80269.js